<template>
  <div class="notes" :note_id="note.id" :time="note.time">
    <div>
      <a class="time_string" @click="video_jump(note.time)">{{note.time_string}}</a>
      <i class="material-icons" style="float: right;" @click="delete_note">delete</i>
      <i class="material-icons" style="float: right;" @click="start_edit_note">edit</i>
    </div>
    <div class="message">{{note.message}}</div>
  </div>
</template>
<script>
export default {
  props: {
    note: Object
  },
  methods: {
    video_jump: function () {
      this.$parent.seekVideo(this.note.time)
    },
    delete_note: function () {
      this.$parent.delete_note(this.note.id)
    },
    start_edit_note: function () {
      this.$parent.startEditNote(this.note)
    }
  }
}
</script>
